import clsx from "clsx";
import { type Component, Show } from "solid-js";
import { useWire } from "~/wire";

/**
 * Status display component for showing streaming progress
 * Shows current status, animated indicator, and accumulated metrics
 */
export const StatusDisplay: Component = () => {
  const wire = useWire();

  // Get status display text based on enum
  const getStatusText = () => {
    if (!wire.chat.isChatStreaming()) return "Ready";
    return "Generating...";
  };

  // Get status display styling
  const getStatusColor = () => {
    if (!wire.chat.isChatStreaming()) return "text-secondary-text";
    return "text-primary-text";
  };

  return (
    <div class="flex items-center gap-2 px-3 py-2 rounded-full bg-tile">
      {/* Status Indicator */}
      <Show when={wire.chat.isChatStreaming()}>
        <div class="w-2 h-2 rounded-full bg-brand animate-pulse" />
      </Show>

      {/* Status Text */}
      <span class={clsx("text-sm font-medium", getStatusColor())}>{getStatusText()}</span>
    </div>
  );
};
